import i18nMixin from '../i18nMixin';
import { coreActions, coreStore, constants } from '@ambita/ambita-components-core';

export function init(tag) {
  tag.mixin(i18nMixin);

  tag.user = coreStore.getUser();

  function onUserChange() {
    tag.user = coreStore.getUser();
    tag.update();
  }

  tag.login = (e: Event) => {
    e.preventDefault();
    coreActions.login(tag.refs.usernameInput.value, tag.refs.passwordInput.value);
  };

  tag.logout = () => {
    coreActions.logout();
  };

  tag.on('mount', () => {
    coreStore.on(constants.core.USER_CHANGE_EVENT, onUserChange);
  });

  tag.on('unmount', () => {
    coreStore.off(constants.core.USER_CHANGE_EVENT, onUserChange);
  });
}
